//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data () {
        return {
            tableData: [],
        }
    },
	methods:{
        queryData: function(){
            var that = this;
            this.$get(this.getStore('sysUrl')+'/node/list', function(data){
                // this.tableData = data;
                var dataArr = [];
                Object.keys(data).forEach(function(item){
                    dataArr.push(data[item]);
                });
                this.tableData = dataArr;
            })
        },
        intoNode: function (node){
            // win.g('./detail.html?nodeguid=' + node.nodecode);
            this.goto({
                path: 'detail',
                query: {
                    nodeguid: node.nodecode
                }
            })
        }

	},
	mounted:function(){
        this.queryData();
	}
}
